import { MaybeRef, MaybeRefOrGetter } from 'vue';
import { useDateFormat } from '@vueuse/core';

const adjustToLocalTime = (date: Date): Date => {
  const offset = date.getTimezoneOffset() / 60;
  const hours = date.getHours();
  date.setHours(hours - offset);
  return date;
};

export function useFormattedDate(rawDate: MaybeRefOrGetter<Date | number | string>, withTime?: boolean) {
  const dateInLocalTime = adjustToLocalTime(new Date(toValue(rawDate)))
  let format = 'MMMM D, YYYY';
  if (!!withTime) format += ', h:mm A';
  
  return useDateFormat(
    dateInLocalTime,
    format,
    { locales: 'en-US' },
  )
}
